// web/src/components/stock/EnableForm.tsx
import { useState } from "react";

import type { StockLocation } from "../../lib/api";

/**
 * Второй шаг включения FBS.
 *
 * Кнопка «Включить FBS» не мутирует, а показывает эту форму: без выбранного
 * города включать нельзя, и спросить город надо ДО записи. Сервер тот же
 * отказ даёт маршрутом — разметку можно обойти, отправив запрос руками, и
 * форма здесь удобство, а не защита.
 */
export function EnableForm({
  count,
  locations,
  busy,
  onCancel,
  onConfirm,
}: {
  count: number;
  locations: StockLocation[];
  busy: boolean;
  onCancel: () => void;
  onConfirm: (chosen: number[]) => void;
}) {
  const [chosen, setChosen] = useState<number[]>([]);

  function toggle(id: number) {
    setChosen((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  }

  return (
    <div
      className="flex flex-wrap items-center gap-3 border-b border-border bg-bg-subtle px-4 py-3 text-[13px]"
      data-annot="форма включения FBS"
    >
      <span className="text-fg-muted">Выбрано строк: {count}. Города:</span>
      {locations.length === 0 && (
        <span className="text-fg-faint">
          Справочник городов недоступен — включение сейчас невозможно.
        </span>
      )}
      {locations.map((loc) => (
        <label
          key={loc.id}
          className="flex items-center gap-1.5 text-fg"
          data-annot={`город ${loc.short || loc.name}`}
        >
          <input
            type="checkbox"
            checked={chosen.includes(loc.id)}
            onChange={() => toggle(loc.id)}
          />
          {loc.short || loc.name}
        </label>
      ))}
      <button
        type="button"
        disabled={chosen.length === 0 || busy}
        onClick={() => onConfirm(chosen)}
        className="h-8 rounded-[var(--radius-ui)] border border-border px-3 text-fg hover:bg-bg-hover disabled:opacity-50"
        data-annot="кнопка Включить"
      >
        Включить
      </button>
      <button
        type="button"
        onClick={onCancel}
        className="h-8 rounded-[var(--radius-ui)] px-3 text-fg-faint hover:text-fg"
      >
        Отмена
      </button>
      {/* Набор ПЕРЕЗАПИСЫВАЕТ прежний: «добавить город сотне строк, у каждой
          свой набор» — операция, результат которой человек предсказать не
          может. Говорим это словами, а не оставляем на догадку. */}
      <span className="w-full text-fg-faint">
        Выбранные города заменят прежний набор у всех выбранных строк.
      </span>
    </div>
  );
}
